import { useAtlasSemanticThemeTokens } from '@issuemanager/apps/client/theme';
import { Typography } from '@mui/material';

interface Props {
  name: string;

  /**
   * Renders the element as a block element
   */
  block?: boolean;
  testId?: string;
}

export default function ({ name, block, testId }: Props) {
  const semantic = useAtlasSemanticThemeTokens();
  const display = block ? 'block' : undefined;

  return (
    <Typography
      // TODO: Remove this when atlas fixes the types
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      /* @ts-ignore */
      variant='textMd'
      fontWeight={900}
      display={display}
      data-testid={testId}
      color={semantic.color.link.default.value}
    >
      {name}
    </Typography>
  );
}
